import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { ClientAdditionalRecipients } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/ClientRecipients/ClientAdditionalRecipients/ClientAdditionalRecipients';
import { hasTooFewSigners } from '~/components/AgreementStudioPage/AgreementStudioProposalMode/Recipients/utils/signingRecipients';
import { useLocaleKeys } from '~/i18n';
import { useClientAdditionalRecipients } from './hooks/useClientAdditionalRecipients';
export const GetClientAdditionalRecipientsModalContentTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientAdditionalRecipientsModalContent(param) {
    let { draft, setDraft, showReviewerErrors, anyOneSigns = false, testId } = param;
    const { t: signingPolicyTexts } = useLocaleKeys('proposal.studio.signingPolicy');
    const { ClientAdditionalRecipientsModalContentTestIds: TID } = useMemo(()=>GetClientAdditionalRecipientsModalContentTID(testId), [
        testId
    ]);
    const { clientContacts, primaryContact, isLoading, onChange, onCreateContact } = useClientAdditionalRecipients(draft, setDraft);
    return /*#__PURE__*/ _jsx(Column, {
        gap: 0,
        testId: TID.Root(),
        children: /*#__PURE__*/ _jsx(ClientAdditionalRecipients, {
            testId: TID.Recipients(),
            clientContacts: clientContacts,
            primaryContact: primaryContact,
            reviewers: draft.reviewers(),
            onChange: onChange,
            onCreateContact: onCreateContact,
            showReviewerErrors: showReviewerErrors,
            signingRule: anyOneSigns ? {
                anyOneSigns,
                error: hasTooFewSigners({
                    anyOneSigns,
                    primaryContact,
                    reviewers: draft.reviewers()
                }) ? signingPolicyTexts.tooFewSigners() : undefined
            } : undefined,
            disabled: isLoading
        })
    });
}
